import React, { useEffect } from 'react';
import CouponLogoImage from '../../../images/coupon-logo.png';
import { TbButton } from '../../../components';
import QrcodeContainer from '../QrcodeContainer';
import { toCanvas, drawLineThrough } from '../utils';
import { useClickStatistic } from '../../../hooks/useStatistic';
import './style.less';

interface PreviewProps {
  imgUrl?: string,
  goodsTitle?: string,
  goodsType?: string,
  originPrice?: number,
  couponValue?: number,
  finalPrice?: number,
  qrcode: string,
  onClear: () => void,
}

const clsPrefix = "c-preview";
const Preview:React.FC<PreviewProps> = ({
  imgUrl,
  goodsTitle = '班服秋季套装韩版学生装演出服韩国 初中高中生英伦风校服 ins港班服秋季套装韩版学生装演出服',
  goodsType = '包邮',
  originPrice = 100,
  couponValue = 10,
  finalPrice = 90,
  qrcode,
  onClear = () => null,
}) => {

  function handleSaveImg() {
    useClickStatistic('qrcode-propaganda', 'save-qrcode-img-button')
    toCanvas('propaganda', '二维码推广图');
  }

  useEffect(() => {
    drawLineThrough();
  }, [originPrice])

  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__title`}>推广页面预览</div>
      <div className={`${clsPrefix}__body`} id="propaganda">
        <div className={`${clsPrefix}__img`}>
        {
          imgUrl ? <img src={imgUrl} alt='' /> : (
            <div className={`${clsPrefix}__empty`}>
              暂无图片
            </div>
          )
        }
        </div>
        <div className={`${clsPrefix}__info`}>
          <div className={`${clsPrefix}__info--header`}>
            <span className={`${clsPrefix}__info--type`}>{goodsType}</span>
            {goodsTitle}
          </div>
          <div className={`${clsPrefix}__info--detail`}>
            <div className={`${clsPrefix}__info--prices`}>
              <div id="line-canvas"></div>
              <p>原价:￥<span className={`${clsPrefix}__info--original`}>{originPrice}</span></p>
              <p>
                <img src={CouponLogoImage} alt="" />
                <span className={`${clsPrefix}__info--coupon`}>{couponValue}元 </span>
              </p>
              <p>
                券后价:<span style={{ color: '#FF5502'}}>￥</span>
                <span className={`${clsPrefix}__info--final`}>{finalPrice}</span>
              </p>
            </div>
            <QrcodeContainer qrcode={qrcode} />
          </div>
        </div>
      </div>
      <div className={`${clsPrefix}__opts`}>
        <TbButton id="saveImg" content="保存图片" width="144px" theme="primary" onClick={handleSaveImg} />
        <TbButton content="清空" width="144px" onClick={onClear} />
      </div>
    </div>
  )
}

export default Preview;